<template>
	<div :class="preCls + 'container-padding'">
		<div :class="preCls + 'content-box'">
			<div :class="preCls + 'filter'">
				<table-searcher v-model="filter.title"
				    placeholder=""
				    style="margin-left: 10px;"
				    @search="search">
				</table-searcher>
			</div>
			<Tabs v-model="active"
			    :animated="false">
				<TabPane label="商品管理"
				    name="mallGoodsIndex">
					<Access name="mallGoodsIndex">
						<router-view :name="$access.aliasToUri('mallGoodsIndex')"
						    :title="title"></router-view>
					</Access>
				</TabPane>
				<TabPane label="订单管理"
				    name="mallOrderIndex">
					<Access name="mallOrderIndex">
						<router-view :name="$access.aliasToUri('mallOrderIndex')"
						    :title="title"></router-view>
					</Access>
				</TabPane>
			</Tabs>
		</div>
	</div>
</template>
<script>
export default {
	name: "MallInfo",

	provide() {
		return { mall: this }
	},

	data() {
		return {
			active: "mallGoodsIndex",
			filter: {
				title: "",
			},
			title: "",
		}
	},

	methods: {
		search() {
			this.title = this.filter.title
			this.$emit("search")
		}
	}
}
</script>